import axios from 'axios';

// API base URL
const runtimeOrigin = (typeof window !== 'undefined' && window.location && window.location.origin)
  ? window.location.origin
  : 'http://localhost:5000';
let base = process.env.REACT_APP_API_URL || runtimeOrigin;
base = base.replace(/\/$/, '');
const API_BASE_URL = base.endsWith('/api') ? base : `${base}/api`;

// Axios instance oluştur
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - token ekle
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jansoft-token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - hata yönetimi
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const message = (error.response?.data?.message || '').toLowerCase();
      const isAuthError = message.includes('token') || message.includes('access token');
      if (isAuthError) {
        console.log('Authentication hatası - logout yapılıyor');
        localStorage.removeItem('jansoft-token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// Kumaş Bilgileri API
export const fabricInfoAPI = {
  // Tüm kumaş bilgilerini getir (filtreleme desteği)
  getAll: (params = {}) => api.get('/fabric-info', { params }),
  
  // Tekil kumaş bilgisi getir
  getById: (id) => api.get(`/fabric-info/${id}`),
  
  // Yeni kumaş bilgisi oluştur
  create: (data) => api.post('/fabric-info', data),
  
  // Kumaş bilgisi güncelle
  update: (id, data) => api.put(`/fabric-info/${id}`, data),
  
  // Kumaş bilgisi sil
  delete: (id) => api.delete(`/fabric-info/${id}`),
  
  // Maliyet hesapla (eski endpoint)
  calculateCost: (data) => api.post('/fabric-info/calculate-cost', data),
  
  // Giyim fiyat hesaplama
  calculateFabricCost: (data) => api.post('/fabric-info/calculate', data),
  
  // Fiyat geçmişini getir
  getPriceHistory: (id) => api.get(`/fabric-info/${id}/price-history`),
  
  // Fiyat listesini export et
  exportPriceList: (params = {}) => api.get('/fabric-info/export/price-list', { params }),
  
  toggleActive: (id) => api.patch(`/fabric-info/${id}/toggle-active`)
};

export default api;
